export enum EntityManagementMode {
  ADD = 'ADD',
  EDIT = 'EDIT',
}
